var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialog-confirm',{ref:"confirm"}),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.post.disabled ==='0')?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"red"},on:{"click":_vm.delete_post}},'v-icon',attrs,false),on),[_vm._v(" mdi-trash-can-outline ")]):_vm._e()]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$th('dialog-post.delete-own-post'))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }